import VueService from "../../vue/VueService";
import EventBus from "../../EventBus";
import ConfigurationService from "../../ConfigurationService";
import hangerIcon from "../../../components/icons/HangerIcon";
import Amplitude from '../../../plugins/Amplitude';

class ProductPageService {
  handle() {
    // init vue
    VueService.initVue();

    this.initButton();
  }

  initButton() {
    // create container and button inside it
    const container = document.createElement('div');
    container.className = 'sizing-app-section product-form__item';

    const button = document.createElement('a');
    button.setAttribute('href', '#');
    button.id = 'find-perfect-size';

    const primarySize = this.getLatestPrimarySize();

    if (primarySize) {
      button.innerHTML = `${hangerIcon} Your perfect size is ${primarySize}`;
    } else {
      button.innerHTML = `${hangerIcon} Find your perfect size...`;
    }

    container.appendChild(button);

    // set click event
    button.onclick = (event) => {
      event.preventDefault();
      EventBus.emit('app.open');
    };

    try {
      const appendAfter = ConfigurationService.option('elements.findYourSize.appendAfter');
      const element = document.querySelector(appendAfter);

      // insert after
      element.parentNode.insertBefore(container, element.nextSibling);

      Amplitude.logEvent('widget button shown');
    } catch (error) {
      console.warn('Sizing-app: Failed to inject button', error);
    }
  }

  updateButtonText(sizeLetter) {
    const button = document.getElementById('find-perfect-size');

    button.innerHTML = `${hangerIcon} Your perfect size is ${sizeLetter}`;
  }

  getLatestPrimarySize() {
    try {
      const store = JSON.parse(localStorage.getItem('sizingApp'));
      if (!store || !store.recommendations || store.recommendations.length === 0) return null;

      const currentProductType = ConfigurationService.getCurrentType();

      const recommendation = store.recommendations.find(recommendation => {
        return recommendation.size_profile.type === currentProductType;
      });

      return recommendation ? recommendation.results.primary.size : null;
    } catch (e) {
      console.error('sizingApp: Failed to get latest result', e);
      return null;
    }
  }
}

export default new ProductPageService();
